<svelte:options customElement="hb-dialogform" />

<script lang="ts">
  import { addComponent, getChildStyleToPass } from "wc-js-utils";
  import pkg from "../../../package.json";
  import { styleSetup as formStyleSetup } from "../form/extra/docs";
  import { styleSetup as dialogStyleSetup } from "../dialog/extra/docs";
  import parseStyle from "style-to-object";
  import type { Component } from "./types/webcomponent.type";
  import type { Events as FormEvents } from "../form/types/webcomponent.type";
  import type { Events as DialogEvents } from "../dialog/types/webcomponent.type";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let dialogStyleToSet: string = $state("");
  let formStyleToSet: string = $state("");
  let parsedStyle: { [x: string]: string } = $state({});

  let {
    id = "",
    // style = "",
    schema = [], // Rinomina per evitare conflitti con la versione elaborata
    describedby = "",
    labelledby = "",
    content = "",
    closelabel = "",
    confirmlabel = "",
    dialogclasses = "",
    title = "",
    backdrop = true,
    keyboard = true,
    show = "no",
  }: Component = $props();

  let formIsValid: boolean = $state(false);

  $effect(() => {
    // if (style) {
    //   parsedStyle = parseStyle(style) as any;
    //   dialogStyleToSet = getChildStyleToPass(
    //     parsedStyle,
    //     dialogStyleSetup?.vars,
    //   );
    //   formStyleToSet = getChildStyleToPass(parsedStyle, formStyleSetup?.vars);
    // }
    if (show === "yes" || (show as unknown) === "") show = "yes";
    else show = "no";
    // if (typeof schema === "string") {
    // 	try {
    // 		schema = JSON.parse(schema);
    // 	} catch (err) {
    // 		console.error("error parsing schema", err);
    // 	}
    // }

    if (typeof backdrop === "string")
      backdrop = backdrop === "true" || backdrop === "yes";
    else if (backdrop === undefined) backdrop = true;
    if (typeof keyboard === "string")
      keyboard = keyboard === "true" || keyboard === "yes";
    else if (keyboard === undefined) keyboard = true;
  });

  addComponent({
    repoName: "@htmlbricks/hb-dialog",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-form",
    version: pkg.version,
  });
  let formValues: any;
  function modalShow(detail: DialogEvents["modalShow"]) {
    show = detail.show ? "yes" : "no";
    dispatch("modalShow", detail);
  }
  function updateForm(detail: FormEvents["update"]) {
    dispatch("updateForm", detail);
    if (detail._valid) formIsValid = true;
    else formIsValid = false;
    detail._id = undefined as any;
    formValues = Object.assign({}, detail, { _id: id });
  }
  function formSubmit(detail: DialogEvents["modalConfirm"]) {
    if (detail.confirm && formValues && formValues._valid) {
      dispatch("modalFormConfirm", formValues);
    } else if (!detail.confirm) {
      dispatch("modalFormCancel", { id: id });

      console.warn("form submit cancelled");
    } else {
      dispatch("modalFormCancel", { id: id, error: "invalid form" });

      console.error("form submit invalid");
    }
  }
</script>

<span>
  <hb-dialog
    style={dialogStyleToSet}
    disable_confirm={formIsValid ? "no" : "yes"}
    id={id ? id + "_modalform" : "modalform" + Date.now()}
    {show}
    {title}
    {confirmlabel}
    {content}
    {closelabel}
    onmodalConfirm={(e: { detail: DialogEvents["modalConfirm"] }) => {
      formSubmit(e.detail);
    }}
    onmodalShow={(e: { detail: DialogEvents["modalShow"] }) => {
      modalShow(e.detail);
    }}
  >
    <div slot="body-content">
      <div><slot name="form-header" /></div>
      {#if schema?.length}<div>
          <hb-form
            style={formStyleToSet}
            {schema}
            onupdate={(e: { detail: FormEvents["update"] }) =>
              updateForm(e.detail)}
            hide_submit="yes"
          ></hb-form>
        </div>{/if}
      <div><slot name="form-footer" /></div>
    </div>
    {#if $$slots.header}
      <div slot="header">
        <slot name="header" />
      </div>
    {/if}
    {#if $$slots["modal-footer"]}
      <div slot="modal-footer">
        <slot name="modal-footer" />
      </div>
    {/if}
    {#if $$slots.footer}
      <div slot="footer">
        <slot name="footer" />
      </div>
    {/if}
    {#if $$slots["close-button-label"]}
      <div slot="close-button-label">
        <slot name="close-button-label" />
      </div>
    {/if}
    {#if $$slots["confirm-button-label"]}
      <div slot="confirm-button-label">
        <slot name="confirm-button-label" />
      </div>
    {/if}
  </hb-dialog>
</span>

<style lang="scss">
  // @forward "./styles/bootstrap.scss";
  @forward "./styles/webcomponent.scss";

  // .modal {
  // 	display: block;
  // }
</style>
